import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import getQuery from '../../helpers/api/get-query'
import OrderItem from '../../types/api/order-item'
import Strapi, { StrapiCreate, StrapiSingle, StrapiUpdate } from '../../types/strapi/strapi'

export const orderItemsApi = createApi({
    reducerPath: 'orderItemsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['Orders', 'Ribbons'],
    endpoints: builder => ({
        createOrderItem: builder.mutation<StrapiSingle<OrderItem>, StrapiCreate<OrderItem>>({
            query: body => ({
                url: '/order-items',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Orders'],
        }),
        updateOrderItem: builder.mutation<StrapiSingle<OrderItem>, StrapiUpdate<OrderItem>>({
            query: ({ docId, body, queryParams }) => ({
                url: getQuery(`/order-items/${docId}`)(queryParams),
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Orders', 'Ribbons'],
        }),
    }),
})

export const { useCreateOrderItemMutation, useUpdateOrderItemMutation } = orderItemsApi
